import axios from '../utils/axios';

export default function getBlacklistedSeeker(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/user/admin/blacklisted-users`, { params })
        .then(response => {
            // Map the new response structure to match the old structure
            if (response.data && response.data.data && response.data.data.data) {
                const mappedUsers = response.data.data.data.blacklistedUsers.map(user => ({
                    id: user.id,
                    name: user.name,
                    email: user.email,
                    phone: user.phone,
                    current_organization: user.currentOrganization
                }));
                return {
                    data: {
                        data: {
                            blacklistedUsers: mappedUsers
                        }
                    }
                };
            }
            return response;
        })
        .catch(err => {
            console.error(err);
            return err;
        });
};
